import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IEntryStatus from '../interfaces/IEntryStatus';

export default function Edit() {     
  const {register, handleSubmit, control, setValue:setFormValue,getValues} = useForm<IEntryStatus>();
  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string' },
    { name: 'is_recall', type: 'boolean'},
    { name: 'is_prank_call', type: 'boolean'},
    {name: 'order', type: 'number'},
  ];
  
    return(
      <CrudEdit 
        model={'entry-status'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'Status successfully updated!'}  
        title={'Edit Entry Status'} 
        getValues={getValues} 
      />
    )
}
